import script from "./notic.vue?vue&type=script&setup=true&lang=ts"
export * from "./notic.vue?vue&type=script&setup=true&lang=ts"

import "./notic.vue?vue&type=style&index=0&id=2ee8338a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee8338a"]])

export default __exports__